import LazyHydrate from 'react-lazy-hydration'

import Box from 'app/components/base/Box'
import Container from 'app/components/base/Container'
import Image from 'app/components/base/Image'
import ReactHtmlParser from 'app/components/base/ReactHtmlParser'
import Stack from 'app/components/base/Stack'
import Text from 'app/components/base/Text'

import ArticleFooter from './components/ArticleFooter'
import ArticleHeader from './components/ArticleHeader'
import ParsedHtmlStylesContainer from './components/ParsedHtmlStylesContainer'
import { replaceArticle } from './helpers/replaceArticle'

interface ArticleFeatureProps {
  title: string
  image: string
  createdAt: string
  body: string
  blogTags: BlogTagModel[]
  shareLink: string
  imageAltText: string
}

const ArticleFeature: RFC<ArticleFeatureProps> = ({
  createdAt,
  image,
  title,
  body,
  blogTags,
  shareLink,
  imageAltText
}) => {
  const mediaLinks = [image]

  return (
    <Stack>
      <Text variant="h1" sx={{ textAlign: 'center', mb: 4 }}>
        {title}
      </Text>

      <Box
        sx={{
          borderRadius: 1,
          position: 'relative',
          width: '100%',
          height: '614px',
          mb: 1,
          display: { xs: 'none', md: 'block' }
        }}
      >
        <Image
          src={image}
          alt={imageAltText || title}
          fill
          objectFit="contain"
          sizes="(max-width: 899px) 50px, 1200px"
          quality={100}
          priority
        />
      </Box>

      <Container sx={{ maxWidth: 730, pt: 3 }}>
        <LazyHydrate whenVisible>
          <ArticleHeader
            createdAt={createdAt}
            shareLink={shareLink}
            media={mediaLinks}
          />
        </LazyHydrate>

        <ParsedHtmlStylesContainer>
          <LazyHydrate whenVisible>
            <ReactHtmlParser
              data={String(body)}
              options={{ replace: replaceArticle }}
            />
          </LazyHydrate>
        </ParsedHtmlStylesContainer>

        <LazyHydrate whenVisible>
          <ArticleFooter
            tags={blogTags}
            createdAt={createdAt}
            shareLink={shareLink}
            media={mediaLinks}
          />
        </LazyHydrate>
      </Container>
    </Stack>
  )
}

export default ArticleFeature
